import React, { useCallback, type JSX } from 'react';
import { trackRedirectEvent } from '@tracking';
import { Redirect } from '../../shared/types/Redirect';
import useRedirect from '../../redirection/useRedirect';
import FormattedMessage from '../../shared/components/WithIntl/FormattedMessage';
import getWindow from '../../shared/dom/getWindow';
import './TransferPageComponent.css';

interface Props {
  redirect: Redirect;
}

const GHOST_MODE_URL_PARAMETER = 'GM';

const TransferPageComponent = ({ redirect }: Props): JSX.Element => {
  const window = getWindow();
  const location = window?.location;
  const search = location?.search || '';

  const isGhostModeByParameter = search.includes(GHOST_MODE_URL_PARAMETER);

  const { partnerName } = redirect;

  const [deepLink, redirectTimer, resolvedGhostMode] = useRedirect(redirect, isGhostModeByParameter);

  const forceRedirection = useCallback(() => {
    if (redirectTimer) {
      clearTimeout(redirectTimer);
    }

    trackRedirectEvent(redirect, true);
  }, [redirect, redirectTimer]);

  if (resolvedGhostMode) {
    return <></>;
  }

  return (
    <div className="main-wrapper">
      <main className="main-content">
        <div className="main-content-inner">
          <div className="company-logo-area">
            <img
              className="company-logo tps-company-logo"
              src="/static_content/web/OMIO_blue.svg"
              alt="omio"
            />
          </div>
          <p>
            <FormattedMessage
              id="monetization.transferpage.headline"
              values={{ partner: partnerName }}
            />
          </p>
        </div>
      </main>
      <footer className="main-footer">
        <FormattedMessage id="WEB_MOB-TRANSFER-REDIRECT_TEXT" />
        <a
          href={deepLink}
          className="force-redirect-link"
          onClick={forceRedirection}
          onKeyPress={forceRedirection}
          role="button"
          tabIndex={0}
        >
          <FormattedMessage id="WEB_MOB-TRANSFER-REDIRECT_LINK" />
        </a>
      </footer>
    </div>
  );
};

export default TransferPageComponent;
